module.exports = __webpack_public_path__ + "static/media/myImage.62cf5e16.png";